import * as yup from "yup";

export const phoneSchema = yup.object().shape({
  phone: yup
    .string()
    .required("errors.phone_required")
    .matches(/^0(5|6|7)[0-9]{8}$/, "errors.phone_invalid")
    .max(14, "errors.phone_max_length"),
});

export const emailSchema = yup.object().shape({
  email: yup
    .string()
    .required("errors.email_required")
    .email("errors.email_invalid")
    .max(60, "errors.email_max_length"),
});

export const passwordSchema = yup.object().shape({
  password: yup
    .string()
    .required("errors.password_required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,20}$/,
      "errors.password_invalid"
    ),
  passwordConfirmation: yup
    .string()
    .required("errors.password_confirmation_required")
    .oneOf([yup.ref("password"), null], "errors.password_mismatch"),
});

export const usernameSchema = yup.object().shape({
  username: yup
    .string()
    .required("register:errors.username_required")
    .matches(/^[^\u0600-\u06FF]+$/, "register:errors.username_arabic_invalid")
    .matches(/^\S*$/, "register:errors.username_whitespace_invalid")
    .matches(/^[A-Za-z0-9_]+$/, "register:errors.username_no_special_chars")
    .min(3, "register:errors.username_min_length")
    .max(30, "register:errors.username_max_length"),
});

export const registerSchema = yup
  .object()
  .shape({
    username: usernameSchema.fields.username,
    password: passwordSchema.fields.password,
    passwordConfirmation: passwordSchema.fields.passwordConfirmation,
    phone: phoneSchema.fields.phone,
    email: emailSchema.fields.email,
    acceptedPrivacy: yup
      .boolean()
      .oneOf([true], "errors.accepted_privacy_required"),
  })
  .required();
